const uiControlMixin = {
    props: {
        params: {
            type: Object,
            default: undefined,
        },
        page: {
            type: Object,
            default: undefined,
        },
        view: {
            type: Object,
            default: undefined,
        },
    },
};
export default uiControlMixin;
